import React from 'react';
import { useIntl } from 'react-intl';

import { BaseField } from './types';
import { FormRowRenderer } from '../FormRowRenderer';
import { DisplayText } from '../OfferDetailsFormFields.styles';

export const OfferId = ({ sidePanelMode, offer }: BaseField) => {
  const intl = useIntl();

  const previewComponent = <DisplayText dir="auto">{offer?.id ?? '-'}</DisplayText>;

  if (sidePanelMode === 'preview') {
    return (
      <FormRowRenderer
        hasContentEditPermission={false}
        label={intl.formatMessage({ id: 'menu.id' })}
        previewComponent={previewComponent}
        editComponent={null}
        labelHtmlFor="offer-id"
        sidePanelMode={sidePanelMode}
        offer={offer}
      />
    );
  }
  return null;
};
